import classNames from 'classnames';
import { observer } from 'mobx-react';
import { cloneElement, ReactElement } from 'react';

import css from './ModularConfiguratorSection.css';

interface ModularConfiguratorSectionProps {
  children: ReactElement<{ className?: string }>;
  className?: string;
  hidden?: boolean;
}

const ModularConfiguratorSection = observer(({ children, className, hidden }: ModularConfiguratorSectionProps) => {
  const inner = <div className={css.inner}>{cloneElement(children, { className: css.content })}</div>;

  return (
    <div className={classNames(css.container, className)} inert={hidden ? true : undefined}>
      {inner}
    </div>
  );
});

export default ModularConfiguratorSection;
